"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenOverlay = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var Overlay_1 = require("./Overlay");
/**
 * @internal
 */
var FullScreenOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(FullScreenOverlay, _super);
    function FullScreenOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.getOverlayStyles = function () {
            return {
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
            };
        };
        _this.state = merge_1.default(_this.state, {
            position: {},
            overflow: "auto",
            scrollTop: 0,
        });
        return _this;
    }
    FullScreenOverlay.prototype.UNSAFE_componentWillMount = function () {
        var body = document.body;
        var overflow = getComputedStyle(body).overflow;
        var scrollTop = body.scrollTop;
        this.setState({
            overflow: overflow,
            scrollTop: scrollTop,
        });
        body.style.overflow = "hidden";
        body.scrollTop = 0;
    };
    FullScreenOverlay.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        var body = document.body;
        body.style.overflow = this.state.overflow;
        body.scrollTop = this.state.scrollTop;
    };
    return FullScreenOverlay;
}(Overlay_1.Overlay));
exports.FullScreenOverlay = FullScreenOverlay;
//# sourceMappingURL=FullScreenOverlay.js.map